import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export abstract class IDefaultSearchFilterService {
  public abstract getDefaultSearchFilter$(): Observable<string>;
}
